import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note7',
  templateUrl: './note7.component.html',
  styleUrls: ['./note7.component.scss'],
})
export class Note7Component implements OnInit {
  note7Form: FormGroup;
  calculativeData: any;
  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      if (data.noteId === Notes.Note7) {
        this.calculativeData = data.response.calculativeData;
        if (
          data.response.userInputData !== null &&
          data.response.userInputData !== undefined &&
          data.response.userInputData.data !== null &&
          data.response.userInputData.data !== undefined
        ) {
          this.editNotes7(data.response.userInputData.data);
        }
      }
    });
  }
  editNotes7(res): void {
    this.note7Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : '',
    });
  }

  setForm(): void {
    this.note7Form = new FormGroup({
      textbox1: new FormControl(''),
    });
  }
}
